import { PlatformType } from './normal'

export type PlatformItem = {
  value: PlatformType
  labelKey: string // i18n translation key
}

export const PLATFORM_CONFIGS: PlatformItem[] = [
  {
    value: PlatformType.Bigcommerce,
    labelKey: 'loyout_app_platform_bigcommerce',
  },
  {
    value: PlatformType.Shopify,
    labelKey: 'loyout_app_platform_shopify',
  },
]

export const PLATFORM_FILTERS: Record<PlatformType, PlatformType[]> = {
  [PlatformType.All]: [PlatformType.Bigcommerce, PlatformType.Shopify],
  [PlatformType.Bigcommerce]: [PlatformType.Bigcommerce],
  [PlatformType.Shopify]: [PlatformType.Shopify],
}

export const getFilteredPlatforms = (
  supportedPlatforms: PlatformType,
): PlatformItem[] => {
  if (supportedPlatforms !== PlatformType.All) {
    return []
  }

  const allowedPlatforms = PLATFORM_FILTERS[supportedPlatforms] || []
  return PLATFORM_CONFIGS.filter((platform) =>
    allowedPlatforms.includes(platform.value),
  )
}
